import { Component, inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConquistaUsuarioResponse } from 'app/shared/models/ei-models';
import { DefaultComponentsModule } from 'app/shared/modules/default-components.module';
import { ConquistaService } from 'app/shared/services/edduca-imob';
import { BadgeDialogComponent } from './badge-dialog/badge-dialog.component';
import { GlobalService } from 'app/shared/services/core';
import { useMenuTracking } from 'app/shared/hooks';

@Component({
  selector: 'app-badges',
  standalone: true,
  imports: [DefaultComponentsModule],
  templateUrl: './badges.component.html',
  styleUrl: './badges.component.scss'
})
export class BadgesComponent implements OnInit {
  private service = inject(ConquistaService);
  private dialog = inject(MatDialog);
  private _gs = inject(GlobalService);

  conquistas: ConquistaUsuarioResponse[] = [];
  
  private menuTracking = useMenuTracking();

  ngOnInit() {
    // Registrar acesso ao menu conquistas para gamificação
    this.menuTracking.registrarAcessoMenu('conquistas');
    
    const userId = this._gs.getIdUserLogged();
    this.service.listarMinhasConquistas(userId).subscribe(res => {
      this.conquistas = res;
    });
  }

  onConquistaClick(c: ConquistaUsuarioResponse) {
    if (!c.conquistada) return;
    this.abrirModal(c);
  }

  abrirModal(conquista: ConquistaUsuarioResponse) {
    this.dialog.open(BadgeDialogComponent, {
      data: conquista,
      width: '50vw',
    });
  }
}
